
import React from "react";
import { motion } from "framer-motion";
import { Navigation } from "@/components/Navigation";
import { Sidebar } from "@/components/Sidebar";
import { MobileNavigation } from "@/components/MobileNavigation";
import { FeaturedCarousel } from "@/components/FeaturedCarousel";
import { ContentTabs } from "@/components/ContentTabs";
import { Footer } from "@/components/Footer";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Index() {
  console.log("Rendering Index page");

  const isMobile = useIsMobile();
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.2
      } 
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5 }
    }
  };
  
  return (
    <motion.div 
      className="min-h-screen bg-background"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <Navigation />
      <div className="hidden sm:block">
        <Sidebar />
      </div>
      <motion.main 
        className={`${isMobile ? 'pt-16 pb-20' : 'sm:pl-16 pt-8 pl-4 pb-16'} pt-8 pl-4 transition-all duration-300`}
        variants={itemVariants}
      >
        <motion.h2 
          className="text-xl font-bold text-center my-8"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          DESTAQUE DA SEMANA!
        </motion.h2>
        <motion.div
          variants={itemVariants}
        >
          <FeaturedCarousel />
        </motion.div>
        <motion.div 
          className="mt-0 max-w-[1920px] mx-auto px-4"
          variants={itemVariants}
        >
          <ContentTabs />
        </motion.div>
      </motion.main>
      <Footer />
      <MobileNavigation />
    </motion.div>
  );
}
